export const reviewSectionStyles = {
	sectionWrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1
	},

	rowsContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2
	}
};
